<template>
    <section class="relative">
      <div class="">
        <nuxt-img
          v-if="desktopImage"
          class="hidden object-cover w-full h-full lg:block"
          sizes="xs:320px sm:440px md:766px lg:1023px xl:1200px 2xl:1400px"
          preload
          fetchpriority="high"
          format="webp"
          :src="desktopImage"
          :alt="desktopAlt"
          width="1920"
          height="1183"
        />
        <nuxt-img
          v-if="mobileImage"
          class="block w-full lg:hidden"
          sizes="xs:320px sm:440px md:766px lg:1023px xl:1200px 2xl:1400px"
          preload
          fetchpriority="high"
          format="webp"
          :src="mobileImage"
          :alt="mobileAlt"
          width="1101"
          height="1183"
        />
      </div>
  
      <div class="absolute inset-0 z-10 px-4 pt-3 mx-auto sm:px-6 md:pt-6 max-w-screen-2xl us-max:px-2">
        <div class="grid">
          <div class="flex justify-end gap-x-3">
            <a
              :href="tollFreeLink"
              class="px-3 py-2.5 text-xs rounded-full sm:px-6 sm:text-sm md:text-base w-fit font-ww-medium"
              style="background-color: rgba(255, 255, 255, 0.5);"
            >
              {{ tollFreeText }}
            </a>
  
            <button
            @click="scrollTo(buttonLink)"
              class="px-3 py-2.5 text-xs text-white rounded-full sm:px-6 sm:text-sm bg-lifeboost-red md:text-base w-fit font-ww-medium"
            >
              {{ shopButtonText }}
            </button>
          </div>
  
          <div class="flex flex-col items-center justify-center sm:mt-6 md:mt-8 lg:mt-2 xl:mt-4 2xl:mt-8 3xl:mt-[10%]">
            <div v-if="logoImage">
              <nuxt-img
                class="hidden w-32 md:block xl:w-40 lg:w-32"
                sizes="xs:128px sm:128px md:128px lg:160px xl:204px 2xl:204px"
                preload
                fetchpriority="high"
                format="webp"
                :src="logoImage"
                :alt="logoAlt"
              />
            </div>
  
            <div class="sm:mt-6 xl:mt-8 lg:mt-1 mt-4 us-max:text-sm us-max:mt-2 lg:text-lg sm:text-lg text-base tracking-[5px] text-lifeboost-red-600 font-ww-bold">
              {{ subheading }}
            </div>
  
            <h1 class="text-4xl lg:text-6xl sm:text-5xl text-lifeboost-red-600 font-ww-bold us-max:text-3xl">
              {{ heading }}
            </h1>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  
  const props = defineProps({
    desktopImage: {
      type: String,
      default: "/assets/images/valentine-hero-big.png",
    },
    desktopAlt: {
      type: String,
      default: "background product",
    },
    mobileImage: {
      type: String,
      default: "/assets/images/valentine-mobile.png",
    },
    mobileAlt: {
      type: String,
      default: "background product",
    },
    tollFreeLink: {
      type: String,
      default: "tel:1-800-479-1596",
    },
    tollFreeText: {
      type: String,
      default: "Call Us Toll Free : 1-800-479-1596",
    },
    shopButtonText: {
      type: String,
      default: "Shop Lifeboost",
    },
    buttonLink: {
      type: String,
      default: "#"
    },
    logoImage: {
      type: String,
      default: "/assets/images/logo-lifeboost-black.png",
    },
    logoAlt: {
      type: String,
      default: "logo",
    },
    subheading: {
      type: String,
      default: "HOLIDAY BUNDLE",
    },
    heading: {
      type: String,
      default: "Valentine’s Day",
    },
  });
  
  
  defineBuilderComponent({
    friendlyName: "HeroProductWithShowcase",
    inputs: [
      {
        name: "desktopImage",
        type: "file",
        friendlyName: "Desktop Background Image",
        allowedFileTypes: ["jpg", "jpeg", "png", "webp"],
        defaultValue: "/assets/images/valentine-hero-big.png",
      },
      {
        name: "desktopAlt",
        type: "string",
        friendlyName: "Desktop Background Alt Text",
        defaultValue: "background product",
      },
      {
        name: "mobileImage",
        type: "file",
        friendlyName: "Mobile Background Image",
        allowedFileTypes: ["jpg", "jpeg", "png", "webp"],
        defaultValue: "/assets/images/valentine-mobile.png",
      },
      {
        name: "mobileAlt",
        type: "string",
        friendlyName: "Mobile Background Alt Text",
        defaultValue: "background product",
      },
      {
        name: "tollFreeLink",
        type: "url",
        friendlyName: "Toll-Free Number Link",
        defaultValue: "tel:1-800-479-1596",
      },
      {
        name: "tollFreeText",
        type: "string",
        friendlyName: "Toll-Free Number Text",
        defaultValue: "Call Us Toll Free : 1-800-479-1596",
      },
      {
        name: "shopButtonText",
        type: "string",
        friendlyName: "Shop Button Text",
        defaultValue: "Shop Lifeboost",
      },
        {
        name: 'buttonLink',
        type: 'text',
        defaultValue: '#'
      },
      {
        name: "logoImage",
        type: "file",
        friendlyName: "Logo Image",
        allowedFileTypes: ["jpg", "jpeg", "png", "webp"],
        defaultValue: "/assets/images/logo-lifeboost-black.png",
      },
      {
        name: "logoAlt",
        type: "string",
        friendlyName: "Logo Alt Text",
        defaultValue: "logo",
      },
      {
        name: "subheading",
        type: "string",
        friendlyName: "Subheading Text",
        defaultValue: "HOLIDAY BUNDLE",
      },
      {
        name: "heading",
        type: "string",
        friendlyName: "Heading Text",
        defaultValue: "Valentine’s Day",
      },
    ],
  });
  </script>
  